export default __webpack_public_path__ + "static/media/photograph - Sarvagya Agrawal.4aed8cf9.jpg";